/** Max width for centered chat content column. */
export const CHAT_COLUMN_MAX_WIDTH = 768;

/** Max width for chat content widgets (charts, etc.). */
export const CHAT_WIDGET_MAX_WIDTH = 400;

/** Horizontal padding shared by user bubbles, widgets, and message rows. */
export const CHAT_MESSAGE_PADDING_HORIZONTAL = '$4';

/** Horizontal padding shared by assistant messages, typing indicator, and logo footer. */
export const CHAT_ASSISTANT_PADDING_HORIZONTAL = '$4';
